import moment from 'moment'
import 'moment/locale/zh-tw'
moment.locale('zh-tw')
import mustacheRender from 'libs/mustacheRender.js'
import _cloneDeep  from 'lodash/cloneDeep'
import _isEqual  from 'lodash/isEqual'
import _isEmpty  from 'lodash/isEmpty'
import _trim  from 'lodash/trim'
import _findIndex  from 'lodash/findIndex'
import _uniqBy  from 'lodash/uniqBy'
import crosstab from 'crosstab'
window._cloneDeep = _cloneDeep
window._isEqual = _isEqual
window._isEmpty = _isEmpty
window._trim = _trim
window._findIndex = _findIndex
window._uniqBy = _uniqBy

class helper {
  constructor() {
    this.moment = moment
    this.init()
  }

  async init() {
    const { default: faker } = await import(
      /* webpackChunkName: "faker" */
      /* webpackPrefetch: true */
      'faker/locale/zh_TW'
    )
    this.faker = faker
    this.crosstab = crosstab
  }

  crosstabBroadcast(key, data) {
    try {
      this.crosstab.broadcast(key, data, null)
    } catch(error) {
      console.warn('device not support crosstab')
    }
  }

  getRecursive(data, key, withoutWarning = false) {
    let result = _cloneDeep(data)
    try {
      let properties = key.split('.')
      if(properties.length == 1) return data[key]
      for(const property of properties) {
        if(result[property] === undefined || result[property] === null) return undefined
        result = result[property]
      }
    } catch (error) {
      if(process.env.NODE_ENV != 'testing') {
        if(!withoutWarning) console.warn(error)
      }
      return undefined
    }
    return result
  }

  setRecursive(data, key, value) {
    let target = data
    try {
      let properties = key.split('.')
      let last = properties.pop()
      for(const property of properties) {
        if(target[property] === undefined) {
          target[property] = {}
        }
        target = target[property]
      }

      if(target === null || target === undefined) {
        target = {}
      }
      target[last] = value
    } catch(error) {
      console.warn(error)
      return data
    }
    return data
  }

  getCountryCodeFromLanguageCode(code, lowercase = false) {
    if(typeof code != 'string') return
    const partials = code.split('-')
    let result = partials.length == 1 ? partials[0] : partials[1]
    if(lowercase) return result.toLowerCase()
    return result
  }

  // logout confirm
  logout(vm) {
    vm.$apopup.base({
      title: vm.i18n('action.logout'),
      content: vm.i18n('confirm.logout'),
      closeLabel: vm.i18n('action.cancel'),
      applyCallback: () => {
        vm.$store.dispatch('token/clean')
        vm.$snotify.success(
          null,
          vm.i18n('logout.success')
        )
      },
    })
  }

  async getCustomVueComponent(component) {
    if(!component) return
    if(typeof component != 'function') return component
    const { default: result } = await component()
    return result
  }

  render(data, variable = {}) {
    return mustacheRender.render(data, variable)
  }

  getSuffixListByDevice() {
    const windowWidth = $(window).width()
    if(windowWidth < 660) return ['middle','small', 'tiny']
    if(windowWidth < 960) return ['middle', 'small', 'tiny']
    if(windowWidth < 1264) return ['large', 'middle', 'small', 'tiny']
    return ['xlarge', 'large', 'middle', 'small', 'tiny']
  }

  // 移除photo list的null項目
  getComputedPhotoList(photos) {
    if(!Array.isArray(photos)) return null
    const validPhotos = photos.filter(photo => !!photo)
    if(validPhotos.length == 0) return null
    return validPhotos
  }

  getPhotoListUrl(photos, suffixList = null) {
    if(!Array.isArray(photos)) return null
    photos = photos.filter(photo => !!photo)
    return this.getPhotoUrl(photos[0], suffixList)
  }

  getPhotoUrl(photo, suffixList = null) {
    if(!photo) return null
    if(photo.url) return photo.url
    if(!photo.size_list) return null
    if(!suffixList) suffixList = this.getSuffixListByDevice()
    const originUrl = photo.size_list.origin.url
    for(const suffix of suffixList) {
      if(photo.size_list[suffix] && photo.size_list[suffix].url) {
        return photo.size_list[suffix].url
      }
    }
    return originUrl
  }

  getPhotoUrlArray(photo) {
    if(!photo) return null
    if(photo.url) return [photo.url]
    if(!photo.size_list) return [photo.size_list]
    let result = []
    for(const suffix in photo.size_list) {
      const photoSizeObject = photo.size_list[suffix]
      if(!photoSizeObject.url) continue
      result.push(photoSizeObject.url)
    }
    return result
  }

  getSize(byte) {
    if(byte < 1024*1024) return `${(byte/1024).toFixed(2)}KB`
    if(byte < 1024*1024*1024) return `${(byte/1024/1024).toFixed(2)}MB`
    return `${(byte/1000/1000/1024).toFixed(2)}GB`
  }

  isImage(file) {
    if(file instanceof File === false) return false
    if(new RegExp(/image\/png/).test(file.type)) return true
    if(new RegExp(/image\/jpg/).test(file.type)) return true
    if(new RegExp(/image\/jpeg/).test(file.type)) return true
    if(new RegExp(/image\/gif/).test(file.type)) return true
    return false
  }

  selectPhoto(vm, type, applyCallback, options = {}) {
    const single = options.single === true
    vm.$apopup.base({
      title: vm.i18n('photo.manager'),
      bodySlot: () => import('modules/photo/components/photoManager/container/popupContainer.vue'),
      width: vm.$isMobile ? '85vw' : '65vw',
      lockType: type,
      applyCallback,
      applyLabel: vm.i18n('photo.action.apply_photo'),
      ...options,
      disabledApply: (data) => {
        if(!Array.isArray(data)) return false
        if(single) return data.length != 1
        return data.length <= 0
      }
    })
  }

  testMailPrompt(vm, send, metaConfig = null) {
    vm.$apopup.prompt({
      width: '400px',
      title: vm.i18n('mail.action.test'),
      content: vm.i18n('mail.action.test.help'),
      disabledApply: (data) => {
        if(typeof data != 'string') return true
        for(const mail of data.split(',')) {
          const isMail = vm.$validator.isEmail(mail)
          if(!isMail) return true
        }
        return false
      },
      applyCallback: send,
      ...metaConfig,
    })
  }

  getCountdown(time) {
    if(!time) return null
    const now = this.moment()
    const diffTime = this.moment(time).diff(now)
    const duration = this.moment.duration(diffTime, 'milliseconds')
    let hours = duration.hours() > 10 ? duration.hours() : `0${duration.hours()}`
    let minutes = duration.minutes() > 10 ? duration.minutes() : `0${duration.minutes()}`
    let seconds = duration.seconds() > 10 ? duration.seconds() : `0${duration.seconds()}`
    let result = seconds
    if(duration.minutes()) result = `${minutes}:${result}`
    if(duration.hours()) result = `${hours}:${result}`
    return result
  }

  afterLoginSuccess(vm, role) {
    this._redirectAfterLoginSuccess(vm)
    if(role == 'user') {
      this._emitLoginSuccessEventAfterLoginSuccess(vm)
    }
  }

  _redirectAfterLoginSuccess(vm) {
    const path = vm.$route.query.path
    if(!path) return
    vm.$router.replace({ path })
  }

  async _emitLoginSuccessEventAfterLoginSuccess(vm) {
    try {
      await vm.$api.userAccount.admin.emitLoginSuccessEvent()
    } catch (error) {
      console.error(error)
    }
  }

  getBreakpointByWidth(width) {
    if(width < 600) return 'xs'
    if(width < 960) return 'sm'
    if(width < 1264) return 'md'
    if(width < 1904) return 'lg'
    return 'xl'
  }

  getDeviceByWidth(width) {
    const breakpoint = this.getBreakpointByWidth(width)
    if(breakpoint == 'xl' || breakpoint == 'lg') return 'desktop'
    if(breakpoint == 'md') return 'tablet'
    if(breakpoint == 'sm' || breakpoint == 'xs') return 'mobile'
    return null
  }

  selectIcon(vm, icon, applyCallback) {
    vm.$apopup.base({
      width: '600px',
      title: vm.i18n('page_category.data.icon'),
      bodySlot: () => import('components/iconSelector/iconSelector.vue'),
      defaultValue: icon,
      disabledApply: data => _isEmpty(_trim(data)),
      applyCallback,
    })
  }
  
  getYoutubeUid(url) {
    if(typeof url != 'string') return null
    //短網址形式
    const short_pattern = /(https:\/\/youtu\.be\/)(.*)/
    if(url.match(short_pattern)) {
      const uid = url.replace(short_pattern, '$2')
      return uid
    }
    //正常形式
    const partial = url.split('v=')
    if(typeof partial[1] != 'string') return null
    const uid = partial[1].split('&')[0 ]
    return uid
  }

  getSize(byte) {
    if(byte < 1024*1024) return `${(byte/1024).toFixed(2)}KB`
    if(byte < 1024*1024*1024) return `${(byte/1024/1024).toFixed(2)}MB`
    return `${(byte/1000/1000/1024).toFixed(2)}GB`
  }

  verifyIdentity(vm, success = null, fail = null) {
    vm.$apopup.base({
      title: vm.i18n('user.verify.help.title'),
      bodySlot: () => import('components/adminVerify/adminVerify.vue'),
      disabledApply: (data) => _isEmpty(_trim(data)),
      applyCallback: async password => {
        try {
          await vm.$api.userAccount.admin.verifyIdentity({ password })
          vm.$snotify.success(null, vm.i18n('user.verify-identity.success'))
          if(typeof success === 'function') success()
        } catch (e) {
          console.error(e)
          vm.$snotify.error(null, vm.i18n('user.verify-identity.fail'))
          if(typeof fail === 'function') fail()
        }
      },
    })
  }

  verifyMemberIdentity(vm, success = null, fail = null, cancelCallback = null) {
    vm.$apopup.base({
      title: vm.i18n('member.verify.help.title'),
      bodySlot: () => import('components/adminVerify/adminVerify.vue'),
      disabledApply: (data) => _isEmpty(_trim(data)),
      closeCallback: (isCancel) => {
        if(!isCancel) return
        if(typeof cancelCallback != 'function') return
        cancelCallback()
      },
      applyCallback: async password => {
        try {
          await vm.$api.member.memberConsole.verifyIdentity({ password })
          vm.$snotify.success(null, vm.i18n('member.verify-identity.success'))
          if(typeof success === 'function') success()
        } catch (e) {
          console.error(e)
          vm.$snotify.error('密碼驗證失敗，請重新輸入密碼', vm.i18n('member.verify-identity.fail'))
          if(typeof fail === 'function') fail()
          throw e
        }
      },
    })
  }

  formRules(vm) {
    return {
      textLengthRule: (value, length) => {
        const error = vm.i18n('base.validation.text_too_less_min', { min: length })
        if(typeof value != 'string') return error
        if(!vm.$validator.isLength(value, { min: length })) return error
        return true
      },
      requiredRule:(value) => {
        return !_isEmpty(_trim(value)) || vm.i18n('base.validation.required')
      },
      validEmail: value => {
        const error = i18n('base.validation.email.incorrect')
        if(this.validate().validEmail(vm, value) === false) return error
        return true
      },
      hasLettersAndNumber: value => {
        const error = i18n('base.validation.should_contain_letters_and_numeric')
        if(this.validate().hasLettersAndNumber(value) === false) return error
        return true
      },
    }
  }

  validate() {
    return {
      isEnglish: (string) => {
        const pattern = new RegExp("[A-Za-z]+")
        if(typeof string != 'string') return false
        return pattern.test(string)
      },
      validZip: (vm, value) => {
        if(typeof value != 'string') return false
        if(vm.$validator.isLength(value, { min: 3 }) === false) return false
        if(vm.$validator.isNumeric(value) === false) return false
        return true
      },
      validEmail: (vm, value) => {
        if(typeof value != 'string') return false
        if(vm.$validator.isEmail(value) === false) return false
        return true
      },
      hasLettersAndNumber: value => {
        if(typeof value != 'string') return false
        const LETTERS_PATTEN = /[a-zA-Z]/
        const NUMERIC_PATTEN = /[0-9]/
        const hasLetters = new RegExp(LETTERS_PATTEN, 'g').test(value) == true
        const hasNumeric = new RegExp(NUMERIC_PATTEN, 'g').test(value) == true
        if(!hasLetters) return false
        if(!hasNumeric) return false
        return true
      },
      minText(vm, value, length) {
        if(typeof value != 'string') return false
        return vm.$validator.isLength(value, { min: length })
      }
    }
  }

  numberFormat(price, locales = "zh-TW") {
    let int_price = parseInt(price)
    if(isNaN(int_price)) return '格式錯誤'
    return new Number(int_price).toLocaleString(locales)
  }

  price(price) {
    if(price === '') return ''
    return `NT ${this.numberFormat(price)}`
  }

  wordType(word) {
    const chi_reg = new RegExp("[\u4E00-\u9FA5]")
    const eng_reg = new RegExp("[A-Za-z]")
    const num_reg = new RegExp("[0-9]")
    if(chi_reg.test(word)) return 'chi' 
    if(eng_reg.test(word)) return 'eng' 
    if(num_reg.test(word)) return 'num' 
    return 'sign'
  }

  /**
   * 
   * @param {*} value 字串
   * @param {*} except array, 可寫'chi','eng','num'
   * @param {*} sign_reg 想排除符號的正規表式
   */
  getByteLen(value, except=[], sign_reg) {
    let len = 0;
    for (let i = 0; i < value.length; i++) {
      const word = value[i]
      const type = this.wordType(word)
      if(except.includes(type)) return -1
      else if(type === 'sign' && sign_reg && sign_reg.test(word)) return -1
      else if(type === 'chi') len += 2 
      else if(['eng', 'num', 'sign'].includes(type)) len += 1
      else return -1
    }
    return len;
  }

  isAdminSizeCode(data) {
    const sizeOptions = [
      '5S', '4S', '3S', '2S', '1S', '0S',
      '0M',
      '0L', '1L', '2L', '3L', '4L', '5L',
      '0F',
    ]
    return sizeOptions.indexOf(data) > -1
  }

  getComputedInstanceItem(instance) {
    let namePartials = []
    if(typeof instance.name === 'string') {
      namePartials = instance.name.split('-')
      instance.option1 = namePartials[0] || null
      instance.option2 = namePartials[1] || null

      // 補漏掉的i18n
      const isAdminSizeCode = this.isAdminSizeCode(instance.option1)
      if(isAdminSizeCode) {
        instance.option1 = i18n(`product.instance-option.data.size.${instance.option1}`)
      }

      const isEnglishColor = this.validate().isEnglish(instance.option2)
      if(isEnglishColor) {
        instance.option2 = i18n(`product.instance-option.data.color.${instance.option2}`)
      }

      if(!instance.option2) {
        instance.name = instance.option1
      }

      if(!!instance.option2) {
        instance.name = `${instance.option1}-${instance.option2}`
      }
    }
    return instance
  }

  // 篩選前台客製化商品名稱(只保留_前方的文字)
  filterCustomTitle(data, productData) {
    let product = _cloneDeep(productData)
    // console.warn('custom type', this.getProductCustomType(product))
    const customType = this.getProductCustomType(product)
    if(typeof data != 'string') return ''
    const partials = customType === 'stamp' ? data.split('_ ') : data.split('_')
    // console.warn('data', data)
    // console.warn('partials', partials)
    if(partials.length < 2) return data

    // 針織保留後段
    if(customType === 'knit') {
      return partials[1]
    }
    return partials[0]
  }

  getProductCustomType(product) {
    if(!product) return null
    if(!_isEmpty(product.knit)) return 'knit'
    if(!_isEmpty(product.knit_ids)) return 'knit'
    if(!_isEmpty(product.knit_data)) return 'knit'

    if(!_isEmpty(product.stamp)) return 'stamp'
    if(!_isEmpty(product.stamp_ids)) return 'stamp'
    if(!_isEmpty(product.stamp_data)) return 'stamp'
    return null
  }

  delay(second) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve()
      }, second*1000)
    })
  }
}

export default new helper()